import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api";

export default function SupportDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [support, setSupport] = useState(null);

  useEffect(() => {
    api.get(`/supports/${id}`).then(r => setSupport(r.data)).catch(() => navigate("/supports"));
  }, [id]);

  if (!support) return <div style={{ padding:32, textAlign:"center" }}>Chargement...</div>;

  const STATUTS = { actif:"#28a745", inactif:"#6c757d", maintenance:"#F5A800", reforme:"#dc3545" };

  return (
    <div style={{ padding:32, maxWidth:800, margin:"0 auto" }}>
      <button onClick={() => navigate("/supports")} style={{ background:"none", border:"none", color:"#1B3A8C", cursor:"pointer", fontSize:14, marginBottom:16 }}>← Retour</button>
      <div style={{ background:"#fff", borderRadius:16, padding:32, boxShadow:"0 4px 20px rgba(0,0,0,0.1)" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:24 }}>
          <div>
            <h1 style={{ fontSize:24, fontWeight:800, color:"#1B3A8C" }}>{support.nom}</h1>
            <div style={{ fontSize:14, color:"#888", marginTop:4 }}>Code: <b style={{ color:"#F5A800" }}>{support.code}</b></div>
          </div>
          <span style={{ background:STATUTS[support.statut]+"22", color:STATUTS[support.statut], padding:"8px 18px", borderRadius:20, fontWeight:700 }}>{support.statut}</span>
        </div>
        {support.photo && <img src={support.photo} alt={support.nom} style={{ width:"100%", height:250, objectFit:"cover", borderRadius:12, marginBottom:24 }} />}
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:24 }}>
          {[["Catégorie",support.Categorie?.nom],["Localisation",support.localisation],["Adresse",support.adresse],["Propriétaire",support.proprietaire],["Valeur",support.valeur ? support.valeur+" GNF" : null],["Date acquisition",support.dateAcquisition]].filter(([,v])=>v).map(([k,v]) => (
            <div key={k} style={{ background:"#f8f9fa", borderRadius:10, padding:"14px 18px" }}>
              <div style={{ fontSize:11, color:"#888", fontWeight:700, textTransform:"uppercase" }}>{k}</div>
              <div style={{ fontSize:15, color:"#222", marginTop:4, fontWeight:600 }}>{v}</div>
            </div>
          ))}
        </div>
        {support.qrCode && (
          <div style={{ textAlign:"center", padding:20, background:"#f8f9fa", borderRadius:12 }}>
            <div style={{ fontWeight:700, color:"#1B3A8C", marginBottom:12 }}>QR Code du support</div>
            <img src={support.qrCode} alt="QR" style={{ width:180, height:180 }} />
            <div style={{ marginTop:12 }}>
              <a href={support.qrCode} download={`QR-${support.code}.png`}
                style={{ background:"#1B3A8C", color:"#fff", padding:"8px 20px", borderRadius:8, textDecoration:"none", fontSize:13, fontWeight:700 }}>
                📥 Télécharger QR Code
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
